<template>
  <th />
</template>

<script>
export default {
  name: 'ExpandableHead'
}
</script>
